// extracted by mini-css-extract-plugin
module.exports = {"grouping_count":"index_grouping_count_1CKuX","right":"index_right_MRfus"};